/**
 * Mostra o formulario de pedido quando a medida escolhida esta esgotada.
 *
 * O QUE ELE FAZ
 *
 * O bloco "Request this product" e montado pelo Liquid sempre que o produto tem
 * ALGUMA medida esgotada, e nasce aberto ou fechado conforme a medida que a
 * pagina abriu (`snippets/product.liquid`, bloco `request_quote`). Daqui em
 * diante quem manda e a escolha da pessoa: trocou para uma medida esgotada, o
 * formulario aparece; trocou para uma a venda, ele sai da frente e o botao de
 * compra volta a ser o unico caminho.
 *
 * POR QUE NAO E O TEMA QUE FAZ ISSO
 *
 * O tema ja preenche os campos escondidos do formulario a cada troca de medida
 * (`ProductDetails._switchVariant` preenche variante, id e SKU), mas nunca
 * decide se o formulario deve estar na tela — ele so existia quando o produto
 * INTEIRO estava esgotado, e ai ficava visivel o tempo todo.
 *
 * COMO, E POR QUE ASSIM
 *
 * Observa o atributo `variant` do `<variant-selection>` mais proximo, o mesmo
 * sinal que o `atc-button-sync.js` usa. Nao escuta o evento `variant-change`
 * porque esse evento se perde no carregamento — e o motivo esta explicado no
 * outro arquivo.
 *
 * Esconder e mostrar sai pelo atributo `hidden`, e nao por classe de CSS: sem
 * este script a pagina continua correta, so parada no estado que o Liquid
 * escreveu. Nada aqui e indispensavel para o formulario funcionar.
 */
(() => {
  const CONTAINER = '[data-request-form-container]';
  const LIGADO = 'soldOutRequestForm';

  /**
   * Depois de enviar, a Shopify volta para a pagina com `contact_posted` — e
   * SEM o `?variant=`. Sem ele o tema abre na primeira medida a venda, e a
   * regra normal esconderia o bloco justamente quando ele carrega a resposta
   * que a pessoa esta esperando ver: o pedido chegava por e-mail e a tela nao
   * dizia nada.
   *
   * Entao, nesse retorno, o bloco fica aberto por cima da regra da medida. Sai
   * desse modo quando a pessoa mexer no seletor — ver a nota do `isTrusted`
   * mais abaixo.
   */
  const veioDoEnvio = () => new URLSearchParams(window.location.search).has('contact_posted');

  const acharSelecao = (elemento) => {
    for (let atual = elemento.parentElement; atual; atual = atual.parentElement) {
      const selecao = atual.querySelector('variant-selection');
      if (selecao) return selecao;
    }

    return null;
  };

  const vigiar = (container) => {
    if (container.dataset[LIGADO]) return;

    const selecao = acharSelecao(container);
    if (!selecao || typeof selecao.getProduct !== 'function') return;

    container.dataset[LIGADO] = '1';

    let modoConfirmacao = veioDoEnvio();

    /**
     * Devolve a medida que foi pedida.
     *
     * A Shopify volta do envio sem o `?variant=`, entao a pagina abre na
     * primeira medida a venda: a pessoa pede o 6 X 6' e volta olhando o
     * 6 X 6-7'. A confirmacao aparece, mas fala de uma medida que nao e a dela.
     *
     * O id fica no `sessionStorage` — some ao fechar a aba, nao viaja entre
     * abas e nao serve para mais nada. Guardar na URL nao daria: quem monta o
     * endereco de volta e a Shopify.
     *
     * A troca e feita pelo mesmo caminho que a pessoa usaria, mexendo no
     * seletor: assim o tema recalcula preco, botao e SKU como sempre faz, e
     * nao precisamos repetir nenhuma dessas contas aqui.
     */
    const CHAVE_MEDIDA = 'luxury:medida-pedida';

    const guardarMedida = () => {
      try {
        sessionStorage.setItem(CHAVE_MEDIDA, selecao.getAttribute('variant') || '');
      } catch (erro) {
        // navegacao privada, ou armazenamento bloqueado: segue sem guardar
      }
    };

    const escolher = (opcao, valor) => {
      if (opcao.tagName === 'SELECT') {
        if (opcao.value === valor) return;
        opcao.value = valor;
        opcao.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const marcado = Array.from(opcao.querySelectorAll('input[type="radio"]'))
        .find((entrada) => entrada.value === valor);

      if (!marcado || marcado.checked) return;

      marcado.checked = true;
      marcado.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const devolverMedida = () => {
      let pedida;

      try {
        pedida = sessionStorage.getItem(CHAVE_MEDIDA);
        sessionStorage.removeItem(CHAVE_MEDIDA);
      } catch (erro) {
        return;
      }

      if (!pedida || String(selecao.getAttribute('variant')) === pedida) return;

      selecao.getProduct().then((produto) => {
        if (!produto || !produto.variants) return;

        const variante = produto.variants.find((v) => String(v.id) === pedida);
        if (!variante) return;

        selecao.querySelectorAll('[data-variant-option]').forEach((opcao) => {
          const indice = parseInt(opcao.dataset.variantOptionIndex, 10);
          const valor = variante.options[indice];
          if (valor !== undefined) escolher(opcao, valor);
        });
      });
    };

    const formularioDePedido = container.querySelector('form');
    if (formularioDePedido) formularioDePedido.addEventListener('submit', guardarMedida);

    if (modoConfirmacao) devolverMedida();

    const conferir = () => {
      if (modoConfirmacao) {
        container.hidden = false;
        return;
      }

      selecao.getProduct().then((produto) => {
        if (!produto || !produto.variants) return;

        const id = selecao.getAttribute('variant');
        const variante = produto.variants.find((v) => String(v.id) === String(id));

        // sem medida identificada ('not-selected', 'unavailable') nao ha o que
        // pedir ainda: fica fora da tela ate a pessoa escolher
        container.hidden = !(variante && variante.available === false);

        // No quick shop o bloco e um link para a pagina do produto. Ele precisa
        // levar a medida escolhida, senao a pagina abre na primeira medida a
        // venda e o formulario nao aparece do outro lado.
        const link = container.querySelector('[data-request-form-link]');
        if (link && variante) {
          const destino = new URL(link.href, window.location.origin);
          destino.searchParams.set('variant', variante.id);
          link.href = `${destino.pathname}${destino.search}#product-request-form`;
        }
      });
    };

    // So uma troca feita PELA PESSOA encerra o modo confirmacao. A primeira
    // versao disto zerava a flag no primeiro aviso do observer — e o primeiro
    // aviso e sempre o do proprio carregamento, quando o tema acerta a selecao
    // sozinho. A protecao morria antes de servir para alguma coisa, e a
    // confirmacao sumia da tela como se nada tivesse sido enviado.
    //
    // `isTrusted` separa os dois casos: so e verdadeiro em evento vindo do
    // teclado ou do mouse. Ajuste automatico do tema nao dispara `change`
    // confiavel, entao a confirmacao fica ate a pessoa mexer no seletor.
    if (modoConfirmacao) {
      document.addEventListener('change', (evento) => {
        if (!evento.isTrusted) return;
        if (!evento.target.closest || !evento.target.closest('[data-variant-option]')) return;

        modoConfirmacao = false;
        conferir();
      }, true);
    }

    new MutationObserver(conferir).observe(selecao, {
      attributes: true,
      attributeFilter: ['variant'],
    });

    conferir();
  };

  let agendado = false;

  const varrer = () => {
    agendado = false;
    document.querySelectorAll(CONTAINER).forEach(vigiar);
  };

  // `setTimeout` e nao `requestAnimationFrame`: em aba de fundo o navegador nao
  // entrega quadros e a flag ficaria presa em `true` para sempre. O mesmo
  // cuidado esta no `atc-button-sync.js`.
  const agendarVarredura = () => {
    if (agendado) return;
    agendado = true;
    setTimeout(varrer, 0);
  };

  varrer();

  // quick shop e qualquer bloco que chegue depois
  new MutationObserver(agendarVarredura).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('load', varrer);
})();
